export async function timeAsyncExecution<T>(action: () => Promise<T>): Promise<[T, number]> {
    const start = Date.now()
    const result = await action()
    return [result, elapsedInMs(start)]
}

export function elapsedInMs(start: number) {
    const end = Date.now()
    return end - start
}
